<template>
  <DsPageLayout
    prevent-loading
    theme="grey"
  >
    <template #header>
      <div class="ds-display-flex ds-height-full wds-container">
        <div class="ds-display-flex ds-align-items-center manuals">
          <p class="ds-font-weight-bold">Device manuals</p>
        </div>
      </div>
    </template>
    <template #content>
      <slot />
    </template>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-once
      v-html="noscriptHtml"
    />
    <!-- eslint-enable vue/no-v-html -->
  </DsPageLayout>
</template>

<script setup>
/**
 * Default Layout
 * will be used on pages where there is no custom layout set
 */
import { DsPageLayout } from 'awds'

const { noscriptHtml } = useLayout()
</script>
<style scoped lang="scss">
@import 'awds/foundation-vars.scss';
@import 'awds/foundation-mixins.scss';

.manuals {
  // to align with gutter
  margin-left: $spacing-12;

  @include screen('small') {
    padding-left: 0;
  }
}
</style>
